import React, { Component, Fragment } from 'react';

import BannerSection from './components/BannerSection'
import InnovationsSection from './components/InnovationsSection'
import NewsSection from './components/NewsSection'

import { connect } from 'react-redux'
import { fetchProducts } from '../../actions/products'
import { fetchNewsList } from '../../actions/newsList'
import { fetchUserData } from '../../actions/user'

class Home extends Component {
    state = {}

    componentDidMount = () => {
        this.props.fetchProducts()
        this.props.fetchUserData()
        this.props.fetchNewsList()
    }

    render() {
        return (
            <Fragment>
                <BannerSection/>
                <InnovationsSection innovations={this.props.products}/>
                <NewsSection news={this.props.newsList}/>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user,
        products: state.products,
        newsList: state.newsList
    }
}

const mapDispatchToProps = {
    fetchProducts,
    fetchNewsList,
    fetchUserData
}

export default connect(mapStateToProps,mapDispatchToProps)(Home)
